import createReducer from 'utils/createReducer';
import {
    SET_FORM_LIST,
    SET_STATUS,
    SET_SEARCH_TERM,
    SET_FORM_LIBRARY_PAGE,
    SET_PAGE_LIMIT_REACHED,
    ADD_FORM_LIST,
    OPEN_SETTINGS_MODAL_ID,
    OPEN_DELETION_MODAL_ID,
    DELETE_FORM_LIBRARY,
} from '../constants';

export const SEARCHING = 'searching';
export const DEFAULT = 'default';
export const FETCHING = 'fetching';

const initialState = {
    formList: [],
    status: DEFAULT,
    searchTerm: '',
    pageLimitReached: false,
    page: 0,
    openSettingsModalId: null,
    openDeletionModalId: null,
};

const handlers = {
    [SET_FORM_LIST]: (state, { payload }) => ({
        ...state,
        formList: payload,
    }),
    [SET_STATUS]: (state, { payload }) => ({
        ...state,
        status: payload,
    }),
    [SET_SEARCH_TERM]: (state, { payload }) => ({
        ...state,
        searchTerm: payload,
    }),
    [SET_FORM_LIBRARY_PAGE]: (state, { payload }) => ({
        ...state,
        page: payload,
    }),
    [SET_PAGE_LIMIT_REACHED]: (state, { payload }) => ({
        ...state,
        pageLimitReached: payload,
    }),
    [ADD_FORM_LIST]: (state, { payload }) => ({
        ...state,
        formList: [...state.formList, ...payload],
    }),
    [OPEN_SETTINGS_MODAL_ID]: (state, { payload }) => ({
        ...state,
        openSettingsModalId: payload,
    }),
    [OPEN_DELETION_MODAL_ID]: (state, { payload }) => ({
        ...state,
        openDeletionModalId: payload,
    }),
    [DELETE_FORM_LIBRARY]: (state, { payload }) => ({
        ...state,
        formList: state.formList.filter((form) => form.id !== payload),
    }),
};

export default createReducer(initialState, handlers);
